goog.provide("shadow.js.shim.module$$carbon$icons_react$es$caret__up$20");
goog.provide("module$shadow_js_shim_module$$carbon$icons_react$es$caret__up$20");
shadow.js.shim.module$$carbon$icons_react$es$caret__up$20 = shadow.js.nativeProvides["@carbon/icons-react/es/caret--up/20"] = shadow$bridge("@carbon/icons-react/es/caret--up/20");
module$shadow_js_shim_module$$carbon$icons_react$es$caret__up$20.default = shadow.js.shim.module$$carbon$icons_react$es$caret__up$20;
